export default __webpack_public_path__ + "static/media/Chiffre affaires Box2Home3.7b243082.svg";